import type {Theme, Components} from "../..";

type SwitchOverrides = Components<Theme>["MuiSwitch"];

const overrides: SwitchOverrides = {
    defaultProps: {
        disableRipple: true,
        disableFocusRipple: true,
        disableTouchRipple: true,
        color: "default",
    },
    styleOverrides: {
        root: ({theme, ownerState}) => ({
            padding: 0,
            margin: theme.spacing(2),
            borderRadius: theme.borderRadius.full,

            ...(ownerState.edge === "start" && {
                marginLeft: theme.spacing(4),
            }),

            ...(ownerState.edge === "end" && {
                marginRight: theme.spacing(4),
            }),

            ...(ownerState.size === "small" && {
                width: 38,
                height: 20,

                "& .MuiSwitch-switchBase": {
                    padding: 2,
                },
            }),

            ...(ownerState.size === "medium" && {
                width: 46,
                height: 24,
            }),

            // needs to lie inside root due to specificity
            "& .MuiSwitch-switchBase.Mui-checked": {
                ...(ownerState.size === "small" && {
                    transform: "translateX(18px)",
                }),

                ...(ownerState.size === "medium" && {
                    transform: "translateX(22px)",
                }),
            },

            "&:has(.Mui-focusVisible)": {
                outline: `2px solid ${theme.color.border.focused}`,
                outlineOffset: 2,
            },
        }),
        thumb: ({theme}) => ({
            backgroundColor: theme.color.fill.surface.default,
            boxShadow: theme.shadows[3],

            ".Mui-checked &": {
                backgroundColor: theme.color.fill.surface.default,
            },

            ".Mui-disabled &": {
                boxShadow: theme.shadows[0],
            },
        }),
        switchBase: ({theme, ownerState}) => ({
            opacity: 1,
            padding: 2,

            "&.Mui-checked": {
                ...(ownerState.size === "small" && {
                    transform: "translateX(18px)",
                }),

                ...(ownerState.size === "medium" && {
                    transform: "translateX(22px)",
                }),

                "& + .MuiSwitch-track": {
                    ...(ownerState.color === "default" && {
                        backgroundColor: theme.color.fill.gametype.assorted.default,
                    }),
                    ...(ownerState.color === "primary" && {
                        backgroundColor: theme.color.fill.gametype.v75.default,
                    }),
                    ...(ownerState.color === "secondary" && {
                        backgroundColor: theme.color.fill.gametype.v86.default,
                    }),
                    ...(ownerState.color === "success" && {
                        backgroundColor: theme.color.fill.gametype.gs75.default,
                    }),
                    ...(ownerState.color === "warning" && {
                        backgroundColor: theme.color.fill.gametype.v64.default,
                    }),
                    ...(ownerState.color === "error" && {
                        backgroundColor: theme.color.fill.gametype.v65.default,
                    }),
                },
                "&:not(.Mui-disabled) + .MuiSwitch-track": {
                    opacity: 1,
                },
            },
        }),
        track: ({theme}) => ({
            borderRadius: theme.borderRadius.full,
            backgroundColor: "rgba(158, 174, 189, 0.6)",
        }),
    },
};

export default overrides;
